import $ from 'jquery';

import {
  getBreakpoint,
  isNotBreakpoint,
  isBreakpoint
} from './helper-responsive.js';

const CLASS_SITE_CONTENT = '.lk-site-content';
const CLASS_SITE = '.lk-site';

const siteNavigation = () => {

  // ********************************************
  // Get Touch / Click Events
  // ********************************************
  var getClickEvent = function() {
    var evt;

    if ('ontouchstart' in window) {
      evt = 'touchstart';
    }
    else if (window.navigator.pointerEnabled) {
      evt = 'pointerdown';
    }
    else if (window.navigator.msPointerEnabled) {
      evt = 'MSPointerDown';
    }
    else {
      evt = 'click';
    }

    return evt;
  };

  // ********************************************
  // Desktop Mega Nav
  // ********************************************
  $.fn.megaNavDesktop = function(desktop_nav, settings) {

    // console.log('$.fn.megaNavDesktop');
    let headerWidth = $('.lk-site-header-desktop .container').width();

    // ********************************************
    // Layout
    // ********************************************
    $(desktop_nav).removeAttr('style');

    var desktop_nav_width = $(desktop_nav).width;

    // add "parent" class to menu elements that have submenu
    $(desktop_nav + ' li').each(function() {
      var parent = $(this).find('ul');
      if (parent.length != 0) {
        $(this).addClass('parent');
      }
    });

    $()

    $(desktop_nav + ' .level-1 > li').each(function() {
      $(this).attr('id', $(this).index());

      if ($(this).hasClass('nav-item-col-sub-menu')) {
        $(this).find('> .sub-menu.level-2').width(headerWidth);
      }

      if ($(this).index() < 3) {
        $(this).addClass('dropdown-to-right');
      }
      else {
        $(this).addClass('dropdown-to-left');
      }


    });

    // // add bg element to level-2
    // var $lvl2_block = $(desktop_nav+' .level-2');
    // $lvl2_block.each( function(){
    // 	if ($(this).find('.level-2-bg').length !== '') {
    // 		//console.log('build separator');
    // 		$(this).prepend('<span class="level-2-bg"></span>');
    // 	}
    // });

    // // add bg element to level-3
    // var $lvl3_block = $(desktop_nav+' .level-2 > li');
    // $lvl3_block.matchHeight();
    // $('.level-2-bg').each( function(){
    // 	$(this).height($lvl3_block.height());
    // });

    // $lvl3_block.each( function(){
    // 	if ($(this).find('.level-3-bg').length !== '') {
    // 		//console.log('build separator');
    // 		$(this).prepend('<span class="level-3-bg"></span>');
    // 	}
    // });

    // ********************************************
    // Check if touch enabled
    // ********************************************
    if (Modernizr.touch) {

      // console.log('Touch Device');

      // swap href with # and add data-href with value of href
      $(desktop_nav + ' .level-1 > li.parent > a').each(function() {
        var lvl1_href = $(this).attr('href');
        $(this).attr('href', '#');
        $(this).data('href', lvl1_href);
      });
      $(desktop_nav + ' .level-2 > li.parent > a').each(function() {
        var lvl1_href = $(this).attr('href');
        $(this).attr('href', '#');
        $(this).data('href', lvl1_href);
      });

      // ********************************************
      // For Touch Devices
      // ********************************************
      $(desktop_nav).addClass('touch-nav');

      // Level 1
      $(desktop_nav).on('touchstart mouseenter focus', '.level-1 > li.parent > a, .level-1 > li.parent > span', function(e) {
        e.stopImmediatePropagation();
        e.preventDefault();

        var li_element = $(this).parent('li')

        if (li_element.hasClass('maintainHover')) {
          // console.log('2ND tap on level 1');

          //alert('2ND tap on level 1');
          deactivateLevel1(li_element);
          var targetHref = $(this).data('href');
          if (targetHref !== undefined) {
            window.location.href = $(this).data('href');
          }
        }
        else {
          // console.log('1ST tap on level 1');
          //alert('1ST tap on level 1');
          $('.level-1 > li').removeClass("maintainHover");
          activateLevel1(li_element);
          return false;
        }

      });

      /*
  			// Level 2
  			$(desktop_nav+' .level-2 > li > a').on('touchstart mouseenter focus', function(e){
  				e.stopImmediatePropagation();
          		e.preventDefault();

  				var li_element = $(this).parent('li')

  				if (li_element.hasClass('maintainHover')) {
  					console.log('level-2 ----------- 2ND tap');
  					// alert('level-2 ----------- 2ND tap');
  					deactivateLevel2(li_element);
  					window.location.href = $(this).data('href');
  				} else {
  					console.log('level-2 ----------- 1ST tap');
  					// alert('level-2 ----------- 1ST tap');
  					$('.level-2 > li').removeClass("maintainHover");
  					activateLevel2(li_element);
  					return false;
  				}

  			});

  			// Level 3
  			$(desktop_nav+' .level-3 > li > a').on('touchstart mouseenter focus', function(e){
  				//e.preventDefault();

  				var li_element = $(this).parent('li')

  				$('.level-3 > li').removeClass("maintainHover");
  				activateLevel2(li_element);

  			});
  		*/

    }
 else {
      // ********************************************
      // Normal Desktop
      // ********************************************

      $(desktop_nav + ' .level-1').on('mouseleave', function() {
        // console.log('mouse over');
        $(this).find('ul').removeClass('open');
        $(this).find('li').removeClass('maintainHover');
      })

      // Level 1
      $(desktop_nav + ' .level-1').menuAim({
        activate: activateLevel1,
        deactivate: deactivateLevel1,
        submenuDirection: 'below'
      });

      /*
      // Level 2
      $(desktop_nav+' .level-2').menuAim({
          activate: activateLevel2,
          deactivate: deactivateLevel2
      });

      // Level 3
      $(desktop_nav+' .level-3').menuAim({
          activate: activateLevel3,
          deactivate: deactivateLevel3
      });
      */

    };

    // ********************************************
    // All Levels
    // ********************************************
    // $(desktop_nav).click(function(e) {
    //     //e.stopPropagation();
    // });

    // function getDataID(element, state){
    // 	var element_link = element.find('a');
    // 	//console.log(element_link.attr('data-component-id'), state);
    // }

    function activateLevel1(row) {

      //console.log('activateLevel1: ');

      var $row = $(row),
        $submenu = $(row).find('.level-2');

      // close l2, l3 after l1 is closed
      var current_index = $row.index();
      //console.log('activateLevel1 on: ', current_index );
      //$('.level-2 li').removeClass('maintainHover');
      $('.level-1 > li').filter(function(index) {
        return index !== current_index
      }).find('ul').removeClass('open');
      $('.level-1 > li').filter(function(index) {
        return index !== current_index
      }).find('.level-2 li').removeClass('maintainHover');
      //removeHover('.level-2 li');
      //$('.level-2').removeClass('open');

      if (Modernizr.touch) {
        // focusout search input field
        $('#searchform > input').blur();
      }

      // close dropdown menu
      //$().closeDropdown();

      //maintainHover(row);
      $row.addClass('maintainHover');
      //$submenu.addClass('open');
    };

    function deactivateLevel1(row) {

      //console.log('deactivateLevel1: ');

      var $row = $(row),
        $submenu = $(row).find('.level-2');

      //getDataID($row, 'OFF');

      $row.removeClass("maintainHover");
      return true;
    };
    /*
    function activateLevel2(row) {

    	//console.log('activateLevel2: ');

        var $row = $(row),
            $submenu = $(row).find('.level-3');

        //getDataID($row, 'ON');

        $('.related-col').removeClass('open');
        $('.level-3 li').removeClass('maintainHover');
        $('.level-3').removeClass('open');

        $('#searchform > input').blur();

        $submenu.addClass('open');
        $row.addClass('maintainHover');

        //$(row).find('.level-3 li').addClass('maintainHover');
        $(row).find('.level-3').addClass('open');
    };
    function deactivateLevel2(row) {

    	//console.log('deactivateLevel2: ');

        var $row = $(row),
            $submenu = $(row).find('.level-3');

        //getDataID($row, 'OFF');

        $submenu.removeClass('open');
        $row.removeClass('maintainHover');
    };
    function activateLevel3(row) {

    	//console.log('activateLevel3: ');

        var $row = $(row),
            $submenu = $(row).find('.related-col')

        $('#searchform > input').blur();

        $('.related-col').removeClass('open');
        $submenu.addClass('open');
        //$submenu.removeClass('hidden');
        $row.addClass('maintainHover');
    };
    function deactivateLevel3(row) {

    	//console.log('deactivateLevel3: ');

        var $row = $(row),
            $submenu = $(row).find('.related-col');

        $submenu.removeClass('open');
        //$submenu.addClass('hidden');
        $row.removeClass('maintainHover');
    };
    */
  };

  // ********************************************
  // Mobile Mega Nav
  // ********************************************
  $.fn.megaNavMobile = function(mobile_nav) {

    // console.log('$.fn.megaNavMobile');

    // ********************************************
    // Layout
    // ********************************************

    var resizeTimer;

    var nav_next_btn = '<span class="fa fa-angle-right"></span>';

    $(mobile_nav).removeAttr('style');

    $(mobile_nav + ' .related-col a').attr('rel', 'nofollow');
    $(mobile_nav + ' .level-3 a').attr('rel', 'nofollow');

    $(mobile_nav).addClass('slide');
    $('#mobile-menu-btn').addClass('slide');
    $(CLASS_SITE).addClass('slide');

    var items = $('.slide');
    var content = $(CLASS_SITE_CONTENT);

    // Copy Secondary nav from site header and inject it into mobile mega nav
    var copySecondaryNav = function() {

      if ($('.mega-nav-mobile').find('.secondary-nav-item').length === 0) {
        $('<li class="secondary-nav-item"></li>').appendTo('.mega-nav-mobile .level-1');
        $('.secondary-nav').clone().appendTo('.secondary-nav-item');
      }
    }

    function mobilecheck() {
      var check = false;
      (function(a) {
        if (/(android|ipad|playbook|silk|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) {
          check = true;
        }
      })(navigator.userAgent || navigator.vendor || window.opera);
      return check;
    };

    var clickevent = mobilecheck() ? 'touchstart' : 'click';

    // Open Mobile nav
    var openNav = function() {
      console.log("Open Mobile nav");

      // focusout search input field
      $('.search-form > input').blur();

      // close dropdown menu
      //$().closeDropdown();

      // slide in menu
      $('.slide').removeClass('is-close').addClass('is-open');
      //$('.slide').addClass('is-open');
      $('body').removeClass('mega-nav-mobile-close').addClass('mega-nav-mobile-open');
      $('html').addClass('mega-nav-mobile-open');

      // Copy Scondary Nav
      copySecondaryNav();
    }

    // Close all nav levels
    var closeNav = function() {
      // slide out menu
      $('.slide').removeClass('is-open').addClass('is-close');
      //$('.slide').removeClass('is-open');
      //$('.slide').removeClass('is-open');
      $('body').removeClass('mega-nav-mobile-open').addClass('mega-nav-mobile-close');
      $('html').removeClass('mega-nav-mobile-open');
      //$('#searchform > input').trigger('focusout');
      $('.search-form > input').blur();

      // TODO: INFA FIX
      $(CLASS_SITE).addClass('mega-nav-mobile-home');
      $('.mega-nav-mobile ul').each(function() {
        $(this).removeClass('nav_level_current');
        $(this).removeClass('nav_level_prev');
      });
    }

    $('#mobile-menu-btn').on(getClickEvent(), function(e) {
      e.stopPropagation();
      e.preventDefault();
      if ($(this).hasClass('is-open')) {
        closeNav();
      }
 else {
        openNav();
      }
    });

    // content.click( function() {
    //     if (content.hasClass('is-open')) {
    //         closeNav();
    //     }
    // });

    $('.nav_close_btn').on('click', function() {
      if (content.hasClass('is-open')) {
        closeNav();
      }
    });


    // ********************************************
    // Func
    // ********************************************

    var clickedLink;
    var clickedLinkTarget;

    //var main_nav = $(target_nav).clone();
    $(mobile_nav).addClass('off_canvas');
    //$('.off_canvas_container').append(main_nav);

    // Add "has_levels" classes to parent li's that contain dropdowns
    $(mobile_nav + ' ul li').each(function() {
      $(this).has('ul').addClass('has_levels');
    });

    $('nav.off_canvas > ul').addClass('nav_level_current');
    $('.site-wrapper').addClass('mega-nav-mobile-home');

    $('.has_levels > a').append('<span class="nav_next_btn">' + nav_next_btn + '</span>');
    $('.has_levels > .no-link').append('<span class="nav_next_btn">' + nav_next_btn + '</span>');

    $(mobile_nav).on('click', '.nav_next_btn', function(e) {
      e.preventDefault();
      if ($(this).closest('ul').hasClass('nav_level_current')) {
        $(this).closest('ul').removeClass('nav_level_current').addClass('nav_level_prev');
      }
      $(this).closest('li').children('ul').addClass('nav_level_current');
      $('.nav_prev_btn').fadeIn(400);
      $('.site-wrapper').removeClass('mega-nav-mobile-home');

      if (!$(this).parent().siblings('ul').find('.mobile-child-nav').length) {
        clickedLink = $(this).parent('a').text();
        if (clickedLink == '') {
          clickedLink = $(this).parent('span').text();
        };
        clickedLinkTarget = $(this).parent('a').attr('href');
        $(this).parent().siblings('ul').prepend('<li class="mobile-child-nav mobile-only"><a class="mobile-nav-back nav_prev_btn" alt="back"></a><a class="mobile-clicked-link nav_prev_btn" href="#">' + clickedLink + '</a></li>');
      }
    });

    $(mobile_nav).on('click', '.nav_prev_btn', function(e) {
      e.preventDefault();
      var current = $('.nav_level_current');
      if (current.closest('li').closest('ul').hasClass('nav_level_prev')) {
        current.closest('li').closest('ul').removeClass('nav_level_prev').addClass('nav_level_current');
      }
      else {
        $('.nav_prev_btn').fadeOut(400);
        $('.site-wrapper').addClass('mega-nav-mobile-home');
      }
      if ($('nav.off_canvas > ul').hasClass('nav_level_current')) {
        $('.nav_prev_btn').fadeOut(400);
        $('.site-wrapper').addClass('mega-nav-mobile-home');
      }
      current.removeClass('nav_level_current');
    });

    $(window).on('resize', function() {

      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function() {

        if ($('#mobile-menu-btn').css('display') === "none") {
          $(items).removeClass('is-open');
        }
        else if (isNotBreakpoint('xs') && isNotBreakpoint('sm')) {
          closeNav();
        }
        // if( $('#mobile-menu-btn').css('display') !== "none" ) {
        //     closeNav();
        // }

        if ($(window).height() < 330) {
          $('#searchform > input').on('focusin', function() {
            $(".social-share-wrapper").hide();
          }).on('focusout', function() {
            $(".social-share-wrapper").show();
          });
        };

      }, 250);

    });
  };

  $(document).on('click', function() {

    // Close Desktop Mega Nav levle 2 submenu
    $('li.maintainHover').removeClass('maintainHover');

  });
  $(document).ready(function() {

    // WP fix
    $('.level-1 .sub-menu').each(function() {
      $(this).addClass('level-2');
    });

    // init Mobile Mega Nav
    $.fn.megaNavMobile('#mega-nav-mobile');

    // init Mega Nav
    $.fn.megaNavDesktop('#mega-nav-desktop');

    // close Mega Nav if clicked/touched outside
    var closeDesktopMegaNav = function() {
      $('li.maintainHover').removeClass('maintainHover');
    }

  });
};

export default siteNavigation;
